<template>
    <div class="full-width" :style="pageStyle" v-loading="loading">
        <div class="title-operation-part">
            <div>
                <span class="page-title-span" v-show="pagePart == 'material'" tkey="商家產品">{{i18n.tkey("lang_shop_item")}}</span>
                <span class="page-title-span" @click="clickReturn" v-show="pagePart == 'quotation'"><font-awesome-icon icon="fa-solid fa-chevron-left" />&nbsp;<span tkey="確認報價單">{{i18n.tkey("lang_check_quotion")}}</span></span>
            </div>

            <div>
                <el-text type="primary" size="large" @click="clickQuotationBtn" v-show="pagePart == 'material'" tkey="拿報價">{{i18n.tkey("lang_get_quo_price")}}</el-text>
            </div>
        </div>

        <div class="page-main-part" v-if="null != companyInfo && pagePart == 'material'">
            <quotationProductExhibition :companyInfo="companyInfo" ref="quotationProductDom" v-show="pagePart == 'material'" />
        </div>

        <div class="page-main-part" v-if="pagePart == 'quotation'" >
            <submitQuotationForm :materialList="selectMaterialList" @save-complete="pagePart = 'material'" />
        </div>
    </div>

</template>

<script setup>
    import quotationProductExhibition from "@/components/shopopee/quotation/quotationProductExhibition"
    import submitQuotationForm from "@/components/shopopee/quotation/submitQuotationForm"
    import {inject, onBeforeMount, provide, ref} from "vue";
    import myUtil from "@/util/util";
    import companyApi from "@/request/companyApi";
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faChevronLeft} from '@fortawesome/free-solid-svg-icons'

    library.add(faChevronLeft)

    const props = defineProps(["fullScreen", "companycode"])

    const i18n = inject("i18n")
    const loading = ref(false)
    const pageStyle = ref(null)

    const pagePart = ref("material")
    const quotationProductDom = ref(null)

    const companyInfo = ref(null)
    const selectMaterialList = ref(null)

    function clickQuotationBtn(){
        var map = quotationProductDom.value.getSelectProductMap()

        var keys = Object.keys(map)

        if (keys.length == 0){
            myUtil.alertWarning(i18n.tkey("lang_please_select_product"))
        }else{
            const list = []

            keys.forEach((key, i) => {
                list.push(map[key])
            })

            selectMaterialList.value = list

            pagePart.value = "quotation"
        }

    }

    function getCompanyInfo(){
        loading.value = true

        const request = companyApi.getSimpleCompanyInfoByCompanycode
        const params = request.getParams()

        params.companycode = props.companycode

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                const obj = {}

                Object.assign(obj, res.detail)

                companyInfo.value = obj
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function getCompanyObj(){
        return companyInfo.value
    }

    function clickReturn(){
        pagePart.value = "material"
    }

    provide('quotationMain', {
        getCompanyObj,
    })

    onBeforeMount(() => {
        getCompanyInfo()

        if (props.fullScreen === false){
            pageStyle.value = {}
        }else{
            pageStyle.value = {
                width: `${window.innerWidth}px`,
                height: `${window.innerHeight}px`
            }
        }
    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .title-operation-part {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 50px;
        box-sizing: border-box;
        padding: 0 10px;
    }

    .page-main-part {
        width: 100%;
        height: calc(100% - 50px);
        box-sizing: border-box;
    }

    .page-title-span {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
    }
</style>